var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg011SgLogisticsService = function Svg011SgLogisticsService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 293.307v-192c0-44.183 35.817-80 80-80h-60c-44.183 0-80 35.817-80 80v192c0 44.183 35.817 80 80 80h60c-44.183 0-80-35.817-80-80z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172 373.307h-72c-44.183 0-80-35.817-80-80v-192c0-44.183 35.817-80 80-80h192c44.183 0 80 35.817 80 80v72",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 101.307v40c0 22.091-17.909 40-40 40h-40c-22.091 0-40-17.909-40-40v-40m139.165 312.658c18.439 32.214 46.952 58.36 82.119 73.695 9.273 4.043 20.16 4.044 29.432 0C450.201 459.977 492 397.061 492 326.816v-33.509c-46.863 0-73.137-40-120-40s-73.137 40-120 40v33.509c0 31.334 8.317 61.209 23.165 87.149z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.02 404.538c-11.133-7.93-20.508-18.242-27.441-30.332a94.672 94.672 0 0 1-9.316-22.656c5.527-2.812 10.566-5.566 15.117-8.047 6.973-3.809 18.633-10.195 21.621-10.195s14.648 6.387 21.621 10.195c4.551 2.48 9.609 5.254 15.137 8.047a95.353 95.353 0 0 1-36.739 52.988z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg011SgLogisticsService;